  
// import "ag-grid-enterprise";
import { AgGridReact } from 'ag-grid-react';


import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { debounce, isEmpty } from 'lodash'
 
import styles from './style.module.css';
import clsx from 'clsx'
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';
import Typography from '../../../design-system/lib/Typography'
import Tag from '../../../design-system/lib/Tag'
import IconProvider from '../../../design-system/lib/IconProvider'
import sort_up from '../../../assets/ic/sort_up.svg'
import sort_down from '../../../assets/ic/sort_down.svg'
import DropDown from '../../../design-system/lib/DropDown'
import { ARROW_LEFT, Settings, sort_down_deactive } from '../../../assets'
import { useDispatch, useSelector } from 'react-redux'
import { ResetNewOrder, TableRangeFilter_Update, Table_ClearSelectedOrders, Table_DeSelectOrder, Table_Init, Table_SelectOrder, Table_SelecteMultiOrders, Table_setData, Table_setStatus } from '../../../Redux/actions/actionNames'
import { TableInstance } from '../table-instance'
import { restClient } from '../../../service/API/axios'
import { getTableOrderList } from './action/getTableOrderList'
// import { getTableDefaultColumn } from './action/getTableDefaultColumn'
import { useContainerDimensions } from './useContainerDimensions'
import { Helmet } from "react-helmet";
import $ from 'jquery';
import TableError from '../../table/table-error'
import TableNoOrder from '../../table/table-noOrder'
import TableNoOrderFilter from '../../table/table-noOrder-filter'
import TableLoading from '../../table/table-loading'
import enlargeIcon from '../../../assets/drag-handle-svgrepo-com 1.svg'

import history from '../../../service/history'
import useDimensions from "react-use-dimensions";
import { LocalData } from '../../../service/localStorage'
import { useTranslation } from 'react-i18next'
import { themeQuartz } from 'ag-grid-enterprise';

const localData = new LocalData();


const myTheme = themeQuartz
	.withParams({
        accentColor: "#1080FF",
        backgroundColor: "#FFFFFF",
        borderColor: "#F4F4F7",
        borderRadius: "4px",
        browserColorScheme: "light",
        cellHorizontalPaddingScale: 1,
        chromeBackgroundColor: {
            ref: "backgroundColor"
        },
        columnBorder: false,
        fontFamily: {
            googleFont: "Inter"
        },
        fontSize: 13,
        foregroundColor: "#484848",
        headerBackgroundColor: "#80808006",
        headerFontSize: 13,
        headerFontWeight: 500,
        headerHeight: "42px",
        headerTextColor: "#808080",
        headerVerticalPaddingScale: 1,
        rowBorder: true,
        rowHeight: "42px",
        rowVerticalPaddingScale: 1,
        sidePanelBorder: false,
        spacing: "6px",
        wrapperBorder: false,
        wrapperBorderRadius: "0px"
    });

function TableList({ table, type, tableLayoutUsedHeight, TablehasError, canClearAll, initTableRef, selectedOrders, data, hasNextPage, tableColumns, hasPreviousPage, totalCount, perPage, page, TableisLoading, conatinerWidth, conatinerHeight }) {
  const dispatch = useDispatch();
  const [deCol, setDeCol] = React.useState(tableColumns)
  const TabledefaultColumnStates = useSelector((state) => state.Table.defaultColumnStates)
  const { t, i18n } = useTranslation();
  const [columns] = React.useState(() => [...deCol])
  const [containerRef, { x, y, width }] = useDimensions();
  const lastRowSelected = useRef(null); // ref => { current: null }
  const [sorting, setSorting] = React.useState([])
  const [lastSelectedId, setLastSelectedId] = React.useState(null)
  const [rowHovered, setRowHovered] = React.useState(null)
  const [columnVisibility, setColumnVisibility] =
    React.useState(TabledefaultColumnStates)
  const [columnOrder, setColumnOrder] = React.useState([])
  const [customLoading, setCustomLoading] = React.useState(false)

  //const selectedOrders = useSelector((state) => state.Table.selectedOrders)




  useEffect(() => {
    dispatch(ResetNewOrder())
  }, []);

  const getServerSideDatasource = () => {
   return {
    getRows: (params) => {
      console.log("[Datasource] - rows requested by grid: ", params);
      // استخراج مد سورت از درخواست grid

//       cursor
// createdAt
// cursorSort
// desc
      const sortingParam = params.request.sortModel || [];
 
         if(sortingParam?.length > 0 ){
          dispatch(TableRangeFilter_Update({key :"cursor" , value :sortingParam[0]?.colId}))
          dispatch(TableRangeFilter_Update({key :"cursorSort" , value :sortingParam[0]?.sort}))

         }else{
          dispatch(TableRangeFilter_Update({key :"cursor" , value :"createdAt"}))
          dispatch(TableRangeFilter_Update({key :"cursorSort" , value : "desc"}))
         }

      // فراخوانی تابع گرفتن داده از سرور با استفاده از پارامتر سورتینگ
      getTableOrderList(null, null, type , (response)=>{
             // به عنوان نمونه فرض شده که response.rows آرایه ردیف‌ها و response.lastRow تعداد کل ردیف‌هاست.
            params.success({
              rowData: response?.orders || [],
              rowCount: response.orders?.length
            });
      }) 
      
      // در صورت نیاز می‌توانید زمان تاخیر را هم شبیه‌سازی کنید.
      // setTimeout(() => { ... }, 500);
    },
  };
};


  useEffect(() => {
    if (!data && !TableisLoading) {
      getTableOrderList(null, null, type)
    }
  }, [data, TableisLoading])
 


  useEffect(() => {
    getTableOrderList(null, null, type)
    dispatch(Table_setStatus({ key: "page", value: 1 }))
  }, [perPage])


  const getFromToPage = useCallback(() => {
    let start = 1;
    let end = totalCount;

    start = (page == 1) ? 1 : perPage * (page - 1) + 1;
    end = hasNextPage ? (perPage * page) : totalCount;


    return `${start}-${end}`

  }, [totalCount, perPage, page, hasNextPage, hasPreviousPage]);


  const getStyle = useCallback(() => {
    let ss = '';

    data?.forEach((item) => {
      ss += ` 

      //  .a${item.id}:hover {background-color: rgba(128, 128, 128, 0.12);}
       
      `
    })
    return ss

  }, [data]);


  const rowSelection = useMemo(() => {
    return {
      mode: 'multiRow'  
    };
  }, []);


  const selectionColumnDef = useMemo(() => {
    return {
      sortable: true,
      resizable: true,
      width: 50,
      suppressHeaderMenuButton: false,
      pinned: 'left',
    };
  }, []);


  const gridOptions = {
    icons: {
       custom_icon: `<img src="${Settings}" alt="Custom Icon" style="width:24px; height:24px;" />`
    },
    // ... existing options ...
};

  const wwid = table ? (width - table.getLeftTotalSize()) : 0
  const wwid2 = table ? (width - table.getLeftTotalSize()) : 0

  const onRowSelected = useCallback(
    (event) => {
 

      if (event.source == "rowDataChanged" || event.source == "api") {
        return null
      }
      if (event.source == "uiSelectAll") {
        return null
      }

      if(event.source == "checkboxSelected"){
           if (!event.node.isSelected()) {
        dispatch(Table_DeSelectOrder(event.node.data.id))
      } else {
        dispatch(Table_SelectOrder(event.node.data))
      }
      }
   


    },
    [window],
  );

  const onMultiRowSelected = useCallback(
    (event) => {
  

      if (event.source == "uiSelectAll") {

        if (event.selectedNodes.length > 0) {
          dispatch(Table_SelecteMultiOrders(data))
        
        } else {
          dispatch({
            type: "Table_DeSelectMultiOrders",
            state: data
          })

        }
      }
 

    },
    [window , data],
  );

  const gridApiRef = React.useRef(null);
  const columnApiRef = React.useRef(null);


 
  // فرض کنید selectedOrders ساختارش یا آرایه‌ای از idهاست.
  // اگر ساختار شما چیزی شبیه { [id]: true } یا [id1, id2, ...] است، کد را مطابقش تغییر بدهید.
  const applySelectedFromStore = React.useCallback((api) => {
    if (!api) return;
    const selectedIds = new Set(
      (Array.isArray(selectedOrders) ? selectedOrders : Object.keys(selectedOrders || {}))
        .map(id => String(id))
    );

    api.deselectAll();
    api.forEachNode((node) => {
      if (node.data && selectedIds.has(String(node.data.id))) {
        node.setSelected(true);
      }
    });
  }, [selectedOrders]);

  const onChangeSort = React.useCallback((event) => {

    setCustomLoading(true)
    const sortingParam = event.columns || [];
 
    if (sortingParam?.length > 0) {
      if (sortingParam[0]?.sort) {
        dispatch(TableRangeFilter_Update({ key: "cursor", value: sortingParam[0]?.colId }))
        dispatch(TableRangeFilter_Update({ key: "cursorSort", value: sortingParam[0]?.sort }))
      } else {
        dispatch(TableRangeFilter_Update({ key: "cursor", value: "createdAt" }))
        dispatch(TableRangeFilter_Update({ key: "cursorSort", value: "desc" }))
      }


    } else {
      dispatch(TableRangeFilter_Update({ key: "cursor", value: "createdAt" }))
      dispatch(TableRangeFilter_Update({ key: "cursorSort", value: "desc" }))
    }

      // فراخوانی تابع گرفتن داده از سرور با استفاده از پارامتر سورتینگ
      getTableOrderList(null, null, type ,()=>{
            setCustomLoading(false)

      }) 
 
  }, [type]);
 


  const restoreColumnStateIfAvailable = useCallback((columnApi) => {

    if (!columnApi) return;
    const key = "mytable";
    try {
      const saved = localStorage.getItem(key);
      if (saved) {
        const state = JSON.parse(saved);
        if (state && Array.isArray(state)) {
          console.log("eawfef dsd", columnApi.applyColumnState)

          columnApi.applyColumnState({
            state: state,
            applyOrder: true,
          });
        } else if (state && typeof state === 'object') {
          // اگر shape متفاوت بود، مطمئن شویم دقیق است
          columnApi.applyColumnState({
            state: state,
            applyOrder: true,
          });
        }
      }
    } catch (e) {
      console.warn('Failed to restore column state', e);
    }
  }, []);


  const onGridReady = (params) => {
        //  getTableOrderList(null, null, type)

    gridApiRef.current = params.api;
    columnApiRef.current = params.api;
 

    // اعمال گزینه‌های انتخاب اولیه
      applySelectedFromStore(params.api);
    //  restoreColumnStateIfAvailable(params.api );

         //const datasource = getServerSideDatasource( );
         //params.api.setGridOption("serverSideDatasource", datasource);
  };

  // وقتی selectedOrders یا داده‌ها تغییر کردند، دوباره اعمال کن
  React.useEffect(() => {
    if (gridApiRef.current && selectedOrders && Object.keys(selectedOrders).length > 0 && data && data.length > 0 && !TableisLoading) {
      applySelectedFromStore(gridApiRef.current);
    //  restoreColumnStateIfAvailable(gridApiRef.current )
    }
  }, [TableisLoading]); // داده‌ها هم ممکن است ردیف‌ها را تغییر دهند

    React.useEffect(() => {
    if (gridApiRef.current) {
      // restoreColumnStateIfAvailable(gridApiRef.current )
    }
  }, [TableisLoading])


  // بعد از تعریف gridApiRef در فایل TableList.js (یا .jsx)
useEffect(() => {
  const hasSelected = Array.isArray(selectedOrders)
    ? selectedOrders.length > 0
    : !!(selectedOrders && Object.keys(selectedOrders).length > 0);

  const api = gridApiRef?.current;
  if (!api) return;

  // Try to detect selection from grid (including uiSelectAll)
  const nodesSelected = api.getSelectedNodes ? api.getSelectedNodes() : [];
  const rowsSelected = api.getSelectedRows ? api.getSelectedRows() : [];

  const displayed = api.getDisplayedRowCount ? api.getDisplayedRowCount() : 0;

 
  // پوشش حالت uiSelectAll: اگر همه ردیف‌های نمایش داده‌شده یا کل دیتابیس انتخاب شده باشند
  const gridHasSelection =
    (nodesSelected && nodesSelected.length > 0) ||
    (rowsSelected && rowsSelected.length > 0) ||
    (displayed >  0 && (rowsSelected?.length || 0 ) === displayed);

  if (!hasSelected && gridHasSelection) {
    api.deselectAll();
  }
}, [selectedOrders]);


  const saveColumnState = React.useCallback((columnApi) => {
    try {
      const key = "mytable";
      const state = columnApi.getColumnState();
      console.log("dwsdwdwd state " , state)
      let xx = state.filter((itemx)=>{
        return itemx.colId != "ag-Grid-SelectionColumn" 
      }) 
       localStorage.setItem("customTable", JSON.stringify(xx));

      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      console.warn('Failed to save column state', e);
    }
  }, []);


  const onColumnEverythingChanged = React.useCallback((e) => {
 
 
      if (columnApiRef.current) {

        saveColumnState(columnApiRef.current, "");
      }
 
  }, [saveColumnState, columnApiRef]);

  let tNoOrder = !TablehasError && !canClearAll() && (data && data.length == 0 && !TableisLoading)
  let tNoOrderFilter = !TablehasError && canClearAll() && (data && data.length == 0) && !TableisLoading

  return (



    <div style={{ width: conatinerWidth, height: `calc(100vh - ${(Object.keys(selectedOrders).length != 0) ? "106" : tableLayoutUsedHeight}px)`, display: "flex", flexDirection: "column" }}>
      <div
        className="ag-theme-quartz" // applying the grid theme

        style={{ flex: "1", width: conatinerWidth }} // the grid will fill the size of the parent container
      >

        {(TablehasError && !TableisLoading) && <TableError />}

        {(!TablehasError && !canClearAll() && (data && data.length == 0 && !TableisLoading)) && <TableNoOrder />}

        {(!TablehasError && canClearAll() && (data && data.length == 0) && !TableisLoading) && <TableNoOrderFilter />}
        {(!TablehasError && !tNoOrder && !tNoOrderFilter) && <AgGridReact
            onColumnMoved={onColumnEverythingChanged}
        onColumnVisible={onColumnEverythingChanged}
         rowModelType={"clientSide"}
         theme={myTheme}
        gridOptions={gridOptions}
          loading={TableisLoading || customLoading}
          columnDefs={tableColumns}
          rowSelection={rowSelection}
          selectionColumnDef={selectionColumnDef}
          pivotMode={false}
          sideBar={{
            toolPanels: [
              {
                   id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "custom_icon", // کلید آیکون سفارشی (تعریف شده در gridOptions.icons)
                toolPanel: "agColumnsToolPanel",
                toolPanelParams: {
                  suppressRowGroups: true,
                  suppressValues: true,
                  suppressPivots: true,
                  suppressPivotMode: true,
                  suppressColumnFilter: true,
                  suppressColumnSelectAll: true,
                  suppressColumnExpandAll: true,
                },
              }
            ],
            position: "right"
          }}
          rowData={customLoading ? [] : data}
          suppressContextMenu={true}
          allowContextMenuWithControlKey={false}
          preventDefaultOnContextMenu={false}
          cellSelection={false}
          enableCellTextSelection={true}
          onRowSelected={onRowSelected}
          onSelectionChanged={onMultiRowSelected}
          onGridReady={onGridReady}
          loadingOverlayComponent={TableLoading}
          onSortChanged={onChangeSort}
 
          // اگر شناسهٔ هر ردیف با داده شما مطابقت دارد، این خط را اضافه کن
          getRowId={(params) => String(params.data?.id)}
        />}




      </div>
      {(data && data.length > 0 && !TablehasError) && <div className={styles.paginationContainer}>

        <div className={styles.firstSection}>
          <Typography weight='Body_Middle_Regular' text={`${getFromToPage()} ${t("from")} ${totalCount}`} textColor='TextDark' />
          <DropDown onClick={item => {
            dispatch(Table_setStatus({ key: "perPage", value: Number(item) }))
          }} placement='topStart' size='Medium' text={`${perPage} ${t("rows")}`} data={[30, 50, 100, 200]} title={perPage} />

        </div>
        <div className={styles.paginationButtonContainer}>
          <div className={clsx(styles.paginationButton, !hasPreviousPage && styles.DisabledpaginationButton)} onClick={hasPreviousPage ? () => { getTableOrderList(true, false, type) } : null} >
            <img src={ARROW_LEFT} />
            <Typography weight='Body_Middle_Medium' text={t('Prev')} textColor='TextDark' />

          </div>

          <div className={clsx(styles.paginationButton, !hasNextPage && styles.DisabledpaginationButton)} onClick={hasNextPage ? () => { getTableOrderList(false, true, type) } : null} >
            <Typography weight='Body_Middle_Medium' text={t('Next')} textColor='TextDark' />
            <img src={ARROW_LEFT} style={{ transform: "rotate(180deg)" }} />
          </div>
        </div>
      </div>}
    </div>

  );
}


export default TableList

 